import {
    AfterViewInit,
    Component,
    Input,
    ViewEncapsulation
} from '@angular/core';

@Component({
    selector: 'account-orders-details-items-components',
    templateUrl: './account.orders.details.items.components.component.html',
    styleUrls: ['./../../../../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountOrdersDetailsItemsComponentsComponent {
    @Input('item') item;
}



// WEBPACK FOOTER //
// /codebuild/output/src3048926480/src/src/app/account/orders/details/items/components/account.orders.details.items.components.component.ts